import React from 'react';
import snakeCaseKeys from 'snakecase-keys';
import { camelCaseEmptyStringRecursive } from '../../../../services/utils';
import { sendAlert } from '../../../../actions/utils';
import MassiveAttendanceFormReplace from './MassiveAttendanceReplaceForm';
import { massiveChangeStatusAttendanceRequest, updateMassiveAttendanceRequest } from '../../../../requests/attendances';
import MassiveAttendanceActionsForm from './MassiveAttendanceActionsForm';

const useMassiveActionHook = (
  selectedRows,
  dispatch,
  setSimpleModalBody,
  setSimpleModalTitle,
  setSimpleModalShow,
  setModalTitle,
  setModalBody,
  setCenterModalShow,
  setSize,
  handleSuccessRequest,
  handleFailureRequest,
  handleModalClose,
  branchOffices
) => {
  const parsedRows = camelCaseEmptyStringRecursive(selectedRows);

  const handleMassiveEdit = () => {
    const { date, shift } = parsedRows[0];

    const hasSameAttendanceDate = parsedRows.every(item => item.date === date);

    if (!hasSameAttendanceDate) {
      dispatch(sendAlert({ kind: 'error', message: 'Todas las asistencias deben ser del mismo día' }));
      return false;
    }

    const hasSameShift = parsedRows.every(item => item.shift?.id === shift?.id);
    if (!hasSameShift) {
      dispatch(sendAlert({ kind: 'error', message: 'Todas las asistencias deben tener el mismo turno' }));
      return false;
    }

    const hasShift = parsedRows.every(item => item.shift === '');

    if (hasShift) {
      dispatch(sendAlert({ kind: 'error', message: 'Todas las asistencias deben tener turno' }));
      return false;
    }

    const handleMassiveUpdateRequest = params => {
      updateMassiveAttendanceRequest({
        dispatch,
        params: snakeCaseKeys(params),
        successCallback: () => handleSuccessRequest('massive-updated'),
        failureCallback: errors => handleFailureRequest(errors, 'massive-updated')
      });

      return true;
    };

    setSimpleModalBody(
      <MassiveAttendanceFormReplace
        attendances={selectedRows}
        attendanceDate={date}
        formRequest={massiveForm => handleMassiveUpdateRequest(massiveForm)}
        handleModalClose={handleModalClose}
        dispatch={dispatch}
        branchOffices={branchOffices}
        parsedRows={parsedRows}
      />
    );

    setSimpleModalTitle('Correción de Marcación');
    setSimpleModalShow(true);
    setSize('lg');

    return true;
  };

  const handleMassiveChangeStatus = data => {
    const departureIds = parsedRows?.flatMap(item =>
      Array.isArray(item.departure) ? item.departure.map(d => d.id) : []
    );
    const arrivalIds = parsedRows?.flatMap(item => (Array.isArray(item.arrival) ? item.arrival.map(d => d.id) : []));
    const arrivalBreakTimeIds = parsedRows?.flatMap(item =>
      Array.isArray(item.arrivalBreakTime) ? item.arrivalBreakTime.map(d => d.id) : []
    );
    const departureBreakTimeIds = parsedRows?.flatMap(item =>
      Array.isArray(item.departureBreakTime) ? item.departureBreakTime.map(d => d.id) : []
    );

    const timeTypes = data?.attendance?.timeType.map(item => item.value);

    const params = {
      attendance: {
        status: data.attendance.status,
        arrivalIds,
        departureIds,
        arrivalBreakTimeIds,
        departureBreakTimeIds,
        timeTypes
      }
    };

    massiveChangeStatusAttendanceRequest({
      dispatch,
      params: snakeCaseKeys(params),
      successCallback: () => handleSuccessRequest('massive-approved'),
      failureCallback: handleFailureRequest
    });
  };

  const handleConfirmMassive = action => {
    switch (action) {
      case 'approved':
        setModalTitle('Activacion Masiva');
        setModalBody(<MassiveAttendanceActionsForm status="active" formRequest={handleMassiveChangeStatus} />);
        setCenterModalShow(true);
        break;
      case 'disabled':
        setModalTitle('Desactivación Masiva');
        setModalBody(<MassiveAttendanceActionsForm status="disabled" formRequest={handleMassiveChangeStatus} />);
        setCenterModalShow(true);
        break;
      default:
        break;
    }

    return true;
  };

  return { handleMassiveEdit, handleConfirmMassive };
};

export default useMassiveActionHook;
